import { render, staticRenderFns } from "./AppTabBar.vue?vue&type=template&id=1f312a3f&scoped=true"
import script from "./AppTabBar.vue?vue&type=script&lang=js"
export * from "./AppTabBar.vue?vue&type=script&lang=js"
import style0 from "./AppTabBar.vue?vue&type=style&index=0&id=1f312a3f&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f312a3f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Workplace\\vueProject\\edu_aim\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f312a3f')) {
      api.createRecord('1f312a3f', component.options)
    } else {
      api.reload('1f312a3f', component.options)
    }
    module.hot.accept("./AppTabBar.vue?vue&type=template&id=1f312a3f&scoped=true", function () {
      api.rerender('1f312a3f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AppTabBar.vue"
export default component.exports